export enum IdentifierSize {
    Large,
    Small,
}
